// MarkdownContent.jsx  (new simplified version)

import React, { useState, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm    from 'remark-gfm';
import remarkMath   from 'remark-math';
import rehypeKatex  from 'rehype-katex';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import 'katex/dist/katex.min.css';

const normaliseLatexDelims = (txt) =>
  txt
    .replace(/\\\((.*?)\\\)/g, (_, m) => `$${m}$`)
    .replace(/\\\[(.*?)\\\]/gs, (_, m) => `$$${m}$$`);

const MarkdownContent = React.memo(({ content }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = (t) => {
    navigator.clipboard.writeText(t);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const processed = useMemo(() => normaliseLatexDelims(content), [content]);

  const components = useMemo(() => ({
    code({ inline, className, children }) {
      const match = /language-(\w+)/.exec(className || '');
      if (inline) return <code>{children}</code>;

      return (
        <div className="markdown-code-container">
          <button onClick={() => handleCopy(String(children))}>
            {copied ? 'Copied!' : 'Copy'}
          </button>
          <SyntaxHighlighter
            style={oneDark}
            language={match?.[1] || 'plaintext'}
            PreTag="div"
          >
            {String(children).replace(/\n$/, '')}
          </SyntaxHighlighter>
        </div>
      );
    },
    table: (props) => <table className="table table-striped table-bordered" {...props} />,
    thead: (props) => <thead className="table-light" {...props} />,
  }), [copied]);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkMath]}
      rehypePlugins={[rehypeKatex]}
      components={components}
    >
      {processed}
    </ReactMarkdown>
  );
});

MarkdownContent.displayName = 'MarkdownContent';

/* ---- export both ways ---- */
export default MarkdownContent;
export { MarkdownContent };